/**
 * Puente mínimo entre el juego y el modo captura de reels. Va en todos los
 * builds, pero sin el módulo de captura (solo con VITE_CAPTURE=1) no hace nada:
 * no hay listener, `active` es false y los eventos se descartan.
 */
import type { Map as MapLibreMap } from "maplibre-gl";

export type CaptureEventName = "clue_shown" | "guess_placed" | "reveal_done" | "round_complete";

export interface CaptureHook {
  onMap(map: MapLibreMap | null): void;
  emit(name: CaptureEventName, data: Record<string, unknown>): void;
  /**
   * Coordenada exacta del toque. Los MouseEvent de Chrome traen píxeles enteros
   * y, cerca del borde del globo, medio píxel son decenas de km; el modo captura
   * usa la posición fraccionaria del PointerEvent.
   */
  preciseTap?(point: { x: number; y: number }): { lat: number; lng: number } | null;
}

let hook: CaptureHook | null = null;
let currentMap: MapLibreMap | null = null;

export const captureBridge = {
  /** true solo cuando el módulo de captura está instalado. */
  active: false,
  attach(h: CaptureHook): void {
    hook = h;
    this.active = true;
    h.onMap(currentMap);
  },
  registerMap(map: MapLibreMap | null): void {
    currentMap = map;
    hook?.onMap(map);
  },
  emit(name: CaptureEventName, data: Record<string, unknown> = {}): void {
    hook?.emit(name, data);
  },
  preciseTap(point: { x: number; y: number }): { lat: number; lng: number } | null {
    return hook?.preciseTap?.(point) ?? null;
  },
};
